import { render, staticRenderFns } from "./additional_charges_table.vue?vue&type=template&id=b4b1418c&scoped=true&"
import script from "./additional_charges_table.vue?vue&type=script&lang=js&"
export * from "./additional_charges_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b1418c",
  null
  
)

export default component.exports